import styled, { css, keyframes } from "styled-components";
import Lottie from "lottie-react";
import checkmark from "../../lottiedata/checkmark.json";
import loadingdots from "../../lottiedata/loadingdots.json";


const LoadingDiv = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: rgb(245, 245, 245);
  justify-content: center;
  align-items: center;
`;

const LoadingCompleteSurvey = styled.div`
  max-width: 600px;
  width: 100%;
  padding: 20px;
  display: block;
  background-color: white;
  margin-top: 30px;
  margin: 20px auto;
  border-radius: 20px;
  @media (max-width: 800px) {
    max-width: 320px;
  }
`;

const floatUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px); /* Start 30px lower */
  }
  to {
    opacity: 1;
    transform: translateY(0); /* End at normal position */
  }
`;


const animationItemStyles = css`
  opacity: 0; /* Start invisible */
  animation-name: ${floatUp};
  animation-duration: 0.6s; /* Animation speed */
  animation-timing-function: ease-out; /* Animation curve */
  animation-fill-mode: forwards; /* Stay visible after animating */
`;

const LoadingHeader = styled.h2`
  text-transform: uppercase;
  ${animationItemStyles}
  animation-delay: 0.3s; /* Header appears second */
  font-family: 'Oswald', sans-serif;
  font-size: 54px;
  color: #1e1e1e;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 20px;
  line-height: 120%;
  max-width: 340px;

  @media (max-width: 800px) {
    font-size: 32px;
    max-width: 280px;
    margin-bottom: 10px;
  }
`;

const LoadingText = styled.h3`
  ${animationItemStyles}
  animation-delay: 0.5s; /* Header appears second */
  font-family: 'Lato', sans-serif;
  font-size: 22px;
  color: #4A4A4A;
  font-weight: 600;
  line-height: 150%;
  text-align: center;
  max-width: 440px;
  margin-bottom: 20px;
  display: flex;
  padding: 10px;
  margin: 0 auto;
  @media (max-width: 800px) {
    font-size: 16px;
    margin-bottom: 10px;
  }
`;

const LoadingHeaderSpan = styled.span`
  color: #0B6DFF;
`;

export const LoadingLottie = styled.div`
  ${animationItemStyles}
  animation-delay: 0.1s; /* Checkmark appears first */
  margin: 0 auto;
  padding-top: 20px;
  max-width: 125px;
  @media (max-width: 800px) {
    max-width: 85px;
  }
`;

export const LoadingDots = styled.div`
  margin: 0 auto;
  max-width: 133px;
  ${animationItemStyles}
  animation-delay: 0.7s; /* Dots appear last */
  @media (max-width: 800px) {
    max-width: 80px;
  }
`;

export function LoadingPagePlanReady() {
  return (
    <LoadingDiv>
      <LoadingCompleteSurvey >
        <LoadingLottie>
          <Lottie autoplay={true} loop={false} animationData={checkmark} />
        </LoadingLottie>
        <LoadingHeader><LoadingHeaderSpan>Your Plan</LoadingHeaderSpan> is ready</LoadingHeader>

        <LoadingDots>
          <Lottie autoplay animationData={loadingdots} />
        </LoadingDots> 
      </LoadingCompleteSurvey>
    </LoadingDiv>
  );
}